module.exports = __webpack_public_path__ + "static/media/dice-six.4e557afc.svg";